<template>
  <div>
    <new-drawer
      :isActive="showDrawer"
      v-if="showNewUi"
      @closed="showDrawer = false"
    />
    <drawer :isActive="showDrawer" v-else @closed="showDrawer = false"></drawer>

    <div
      :class="showNewUi ? 'new-fixed-banner' : 'fixed-banner'"
      style="background-color: whitesmoke"
    >
      <div
        :class="showNewUi && 'pb-0'"
        :style="getHeaderStyle()"
        class="container-fluid mobile-banner"
      >
        <div class="d-flex align-items-center justify-content-between">
          <div v-if="loginEnabled" class="shop-title">
            <a
              :class="getIconClass()"
              :style="mobileStyles.navText"
              @click.prevent="hClick"
            >
              <span class="material-icons md-36" :style="getDrawerMenuStyle()"
                >menu</span
              >
            </a>
          </div>
          <div v-if="getLogo && showLogo">
            <img
              :src="getLogo"
              alt="logo"
              :style="
                showLogo && getLogo
                  ? loginEnabled
                    ? 'margin-left: -1.2rem'
                    : 'margin-left : -0.5rem'
                  : ''
              "
              class="logo"
              @error="showLogoError"
            />
          </div>
          <div
            class="d-flex align-items-center flex-grow-1"
            style="
              height: 52px;
              min-width: 0;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            "
            @click="navigateToHome()"
          >
            <span
              class="title-text pl-1"
              style="font-weight: bold !important"
              v-show="currentStoreDoc.StoreTitle"
              >{{ currentStoreDoc.StoreTitle }}</span
            >
            <span
              class="title-text pl-1"
              style="font-weight: bold !important"
              v-show="!currentStoreDoc.StoreTitle && !isGift"
            >
              {{ currentStoreDoc.Name }}
            </span>
          </div>
          <div>
            <ul
              class="nav float-right d-flex justify-content-center align-items-center"
              style="flex-wrap: nowrap !important"
            >
              <li v-if="enableStamps">
                <router-link
                  :to="{
                    name: 'stamps',
                    params: {
                      storename: storeDoc,
                    },
                  }"
                >
                  <img
                    style="width: 25px"
                    src="../../../assets/images/loyalty/loyalty-card.png"
                    alt=""
                  />
                </router-link>
              </li>
              <li v-if="showSharedCart" @click="$emit('handleDisplayBill')">
                <button
                  class="bg-gray text-dark text-center br-5 px-3 py-1 mr-3 font-weight-normal shadow border-0"
                >
                  Bill
                </button>
              </li>
              <li
                v-if="payTableEnabled && storeTable"
                @click="navigateToPayAtTable"
              >
                <img
                  alt=""
                  class="pr-2"
                  src="../../../assets/pay_at_table.png"
                  style="width: 2rem"
                />
              </li>
              <li v-if="displayDietary" class="ml-2" :class="getDietaryClass()">
                <div
                  v-show="showDietary"
                  :style="mobileStyles.TitleBarBorderColor"
                  class="polygon"
                ></div>
                <a
                  id="dietaryNavbarDropdown"
                  v-if="!isGift"
                  href="#"
                  role="button"
                  @click.prevent="openDietary()"
                >
                  <span>
                    <abacus-svg :nav-color="mobileStyles.navText" />
                  </span>
                </a>
                <div
                  class="dietary-container"
                  v-show="showDietary"
                  :style="mobileStyles.TitleBar"
                >
                  <div>
                    <div
                      v-for="allergy in getUsedLifeStyles.allergies"
                      :key="'allergy' + allergy.Id"
                    >
                      <label class="checkbox-label d-flex">
                        <div
                          class="dietary-icon"
                          :style="getIconStyle(allergy)"
                        ></div>
                        <input
                          type="checkbox"
                          :checked="allergy.isSelected"
                          @click="allergyChecked(allergy)"
                        />
                        <span
                          class="checkbox-checkmark right"
                          :style="getStyle()"
                        ></span>
                        {{ allergy.Name }}
                      </label>
                    </div>
                    <div
                      v-for="intolerance in getUsedLifeStyles.intolerances"
                      :key="'intolerance' + intolerance.Id"
                    >
                      <label class="checkbox-label d-flex">
                        <div
                          class="dietary-icon"
                          :style="getIconStyle(intolerance)"
                        ></div>
                        <input
                          type="checkbox"
                          :checked="intolerance.isSelected"
                          @click="intoleranceChecked(intolerance)"
                        />
                        <span
                          class="checkbox-checkmark right"
                          :style="getStyle()"
                        ></span>
                        {{ intolerance.Name }}
                      </label>
                    </div>
                    <div
                      v-for="preference in getUsedLifeStyles.preferences"
                      :key="'preference' + preference.Id"
                    >
                      <label class="checkbox-label d-flex">
                        <div
                          class="dietary-icon"
                          :style="getIconStyle(preference)"
                        ></div>
                        <input
                          type="checkbox"
                          :checked="preference.isSelected"
                          @click="preferencesChecked(preference)"
                        />
                        <span
                          class="checkbox-checkmark right"
                          :style="getStyle()"
                        ></span>
                        <span :style="mobileStyles.navText">
                          {{ preference.Name }}
                        </span>
                      </label>
                    </div>
                  </div>
                  <a class="clear-all" @click="clearAllDietarySelection()">{{
                    $t("message.ClearAll")
                  }}</a>
                </div>
              </li>
              <li class="dropdown" :class="!showNewUi && 'language'">
                <a
                  id="navbarDropdown"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span
                    :class="getIconClass()"
                    :style="mobileStyles.navText"
                    v-if="showNewUi"
                  >
                    <router-link
                      v-if="(storeSupportsLoyaltyPoints || storeSupportEarningLoyaltyPoints) && user"
                      :to="{
                        name: 'loyalty',
                        params: {
                          storeid: storeDoc.ID,
                          storename: storeDoc,
                        },
                      }"
                    >
                      <loyalty-svg :nav-color="mobileStyles.navText" />
                    </router-link>
                  </span>

                  <span :class="getIconClass()" :style="mobileStyles.navText">
                    <i class="fa fa-1-5x fa-globe pl-2"></i>
                  </span>
                </a>
                <div
                  class="dropdown-menu lg-dropdown-menu"
                  style="margin-top: 30px"
                  :style="mobileStyles.TitleBar"
                  aria-labelledby="navbarDropdown"
                >
                  <a
                    v-for="(lang, index) in getAvailableLanguages"
                    :key="index"
                    href="javascript:void(0)"
                    class="dropdown-item pl-0"
                    :class="getIconClass()"
                    :style="mobileStyles.navText"
                    @click="setLocale(lang.locale)"
                    >{{ lang.name }}</a
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="!isGiftCard">
        <div
          v-if="
            !showPopular && OrdersData.length > 0 && ReorderStatus && !showNewUi
          "
          class="container-fluid"
          @touchstart="taphandler"
        >
          <ReorderSlide :orders="OrdersData" @SkipPressed="hideReorder()" />
        </div>
        <confirmationModal></confirmationModal>
        <div
          class="container-fluid category-naviagtion"
          :style="mobileStyles.nav"
        >
          <div
            class="w-100 search-product pt-3"
            :style="getSearchContainerRolldStyles()"
          >
            <div class="d-flex align-items-center justify-content-between">
              <div
                class="new-search-box d-flex"
                :class="displayOrderSelect ? 'w-auto' : 'w-100'"
              >
                <i class="fa fa-search new-fa-search" aria-hidden="true"></i>
                <input
                  type="text"
                  v-model="filterText"
                  class="form-input shadow"
                  :placeholder="getSearchProductsPlaceholder"
                  :style="getSearchRolldStyles()"
                  @input="scrollToHere()"
                />
              </div>
              <div class="w-40 pl-3" v-if="displayOrderSelect">
                <order-type-select />
              </div>
            </div>
          </div>
          <div :class="showNewUi && 'mt-2'" class="row">
            <ul class="store-menu-mobile">
              <li
                v-for="category in categories"
                :key="category.ID"
                v-show="category.SubMenuItems.length"
                :style="itemStyle(category)"
                @click="updateSelected(category)"
              >
                <a
                  :href="'#section-' + category.ID"
                  :style="itemHover(category)"
                  >{{ getCategoryName(category) }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <footer
      class="full-extras-footer"
      :style="getCartOpen && 'z-index: 0'"
      v-show="
        (isGift === true && giftCartTotalQuantity > 0) ||
        (cartTotalQuantity > 0 && isGift === false)
      "
    >
      <router-link
        v-if="isGift"
        :to="{
          name: 'giftshoppingcartmobile',
          params: { storeid: storeId, storename: $route.params.storename },
        }"
      >
        <button type="submit" class="btn btn-primary">
          <span class="view-cart">
            <span class="material-icons md-36">shopping_cart</span>
            {{ $t("message.viewCart") }} ({{ giftCartTotalQuantity }})
          </span>
          <span>{{ cartTotal | formatMoney(currencySign) }}</span>
        </button>
      </router-link>

      <button
        v-else-if="!isDigitalDisplay"
        type="submit"
        @click="navigateToShoppingCart()"
        class="btn btn-primary"
        :style="mobileStyles.btn"
      >
        <span class="view-cart">
          <span class="material-icons">shopping_cart</span>
          {{ $t("message.viewCart") }} ({{ cartTotalQuantity }})
        </span>
        <span class="total">{{ cartTotal | formatMoney(currencySign) }}</span>
      </button>
    </footer>
  </div>
</template>
<script>
import $ from "jquery";
import { $$ } from "./../../../sharedscripts/OO_jquery";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { Validator } from "vee-validate";
import en from "vee-validate/dist/locale/en";
import zh_CN from "vee-validate/dist/locale/zh_CN";
import drawer from "../../shared/drawer";
// import ReorderSlide from "../../shared/ReorderSlide";
import confirmationModal from "../../confirmationModal.vue";
import NewDrawer from "@/components/shared/newDrawer";
import { AppConfig } from "../../../../AppConfig";
import shared from "../../../sharedscripts/shop/ordertype/SupportedOrderType";
import OrderTypeSelect from "@/components/shared/OrderTypeSelect.vue";
import AbacusSvg from "@/components/abacusSvg.vue";
import LoyaltySvg from "@/components/loyaltySvg.vue";

export default {
  name: "ShopHeader",
  components: {
    LoyaltySvg,
    AbacusSvg,
    OrderTypeSelect,
    NewDrawer,
    drawer,
    // ReorderSlide,
    confirmationModal,
  },
  props: {
    menu: {
      type: Object,
      default: () => {},
    },
    storeId: {
      type: String,
      default: "",
    },
    categories: {
      type: Array,
      default: () => [],
    },
    showSearchBox: {
      type: Boolean,
      default: false,
    },
    showPopular: Boolean,
    isGiftCard: {
      type: Boolean,
      default: false,
    },
    handleDisplayBill: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      ReorderStatus: true,
      store: Object,
      activeMenu: 0,
      once: true,
      showDrawer: false,
      selected: null,
      showLogo: true,
      showDietary: false,
      filterText: "",
      mylatesttap: null,
      OrdersData: [],
    };
  },
  watch: {
    categories() {
      this.$nextTick(() => {
        this.doScroll();
      });
    },
  },
  computed: {
    ...mapGetters([
      "activePopup",
      "getMobileEmbededReturnUrl",
      "getAvailableLanguages",
      "currentStoreDoc",
      "user",
      "cartValue",
      "cartItems",
      "giftCartItems",
      "newGiftShoppingCart/giftCartValue",
      "isGift",
      "cartTotalQuantity",
      "giftCartTotalQuantity",
      "viewConfig",
      "mobileStyles",
      "storeSelectionAtCheckoutMode",
      "getUsedLifeStyles",
      "getDietarySelection",
      "isDigitalDisplay",
      "hqDoc",
      "viewConfig",
      "currencySign",
      "storeSupportsLoyaltyPoints",
      "payTableEnabled",
      "getAddToCartOpen",
      "getSelectedMenuType",
      "getTotalPriceWithoutTips",
      "showSharedCart",
      "enableStamps",
      "storeSupportEarningLoyaltyPoints",
    ]),
    ...shared.computed,
    storeDoc() {
      return this.currentStoreDoc ? this.currentStoreDoc.ID : this.currentstore;
    },
    cartTotal() {
      return this.isGift ? this.giftCartValue : this.cartValue;
    },
    getSearchProductsPlaceholder() {
      return this.$t("message.SearchProducts");
    },
    getLogo() {
      if (!this.isRolldStore()) {
        return this.currentStoreDoc.Logo;
      } else {
        return this.hqDoc ? this.hqDoc.Logo : this.currentStoreDoc.Logo;
      }
    },
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
    getCartOpen() {
      return this.showNewUi && this.getAddToCartOpen;
    },
    displayDietary() {
      return (
        this.getUsedLifeStyles.allergies.length > 0 ||
        this.getUsedLifeStyles.intolerances.length > 0 ||
        this.getUsedLifeStyles.preferences.length > 0
      );
    },
    loginEnabled() {
      return this.viewConfig.LogIn;
    },

    storeTable() {
      return sessionStorage.getItem("table");
    },
  },

  updated() {
    this.doScroll();
  },
  mounted() {
    this.updateSelected(this.categories[0]);
    let odata = localStorage.getItem(this.currentStoreDoc.ID + "-OrdersDatas");
    this.OrdersData = odata != null ? JSON.parse(odata) : [];
    if (!this.OrdersData.length > 0) this.hideReorder();
  },
  methods: {
    ...mapMutations([
      "setCurrentLocale",
      "setShowDeliveryFee",
      "setAllergySelected",
      "setIntoleranceSelected",
      "setPreferenceSelected",
      "setSelectedMenuType",
      "setOrderTypeModalDisplay",
      "setIsDelivery",
    ]),
    ...mapActions(["setDisplayBill"]),
    itemHover(category) {
      var style = [];
      if (this.selected && this.selected.ID == category.ID) {
        style.push(this.mobileStyles.MenuHighlightedText);
      }
      if (style.length == 0) {
        style.push(this.mobileStyles.navText);
      }
      return style;
    },
    taphandler() {
      var now = new Date().getTime();

      var timesince = now - this.mylatesttap;
      if (timesince < 500 && timesince > 0) {
        event.preventDefault();
      }
      this.mylatesttap = new Date().getTime();
    },
    scrollToHere() {
      this.$emit("filterText", this.filterText);
    },
    hideReorder() {
      if (this.currentStoreDoc) {
        localStorage.removeItem(this.currentStoreDoc.ID + "-OrdersDatas");
        this.ReorderStatus = false;
        this.$emit("show-reorder", this.ReorderStatus);
      }
    },
    hClick() {
      this.showDrawer = true;
    },
    navigateToShoppingCart() {
      this.setShowDeliveryFee(true);
      if (this.storeSelectionAtCheckoutMode) {
        this.$router.push({
          name: "mainpage",
          query: {
            selectMode: true,
          },
        });
      } else {
        this.$router.push({
          name: "shoppingcartmobile",
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
          },
        });
      }
    },
    scrollTo(element, to, duration) {
      var start = element.scrollTop,
        change = to - start,
        increment = 20;
      var that = this;
      var animateScroll = function (elapsedTime) {
        elapsedTime += increment;
        var position = that.easeInOut(elapsedTime, start, change, duration);
        element.scrollTop = position;
        if (elapsedTime < duration) {
          setTimeout(function () {
            animateScroll(elapsedTime);
          }, increment);
        } else {
          localStorage.setItem("animating", false);
        }
      };

      animateScroll(0);
    },
    easeInOut(currentTime, start, change, duration) {
      currentTime /= duration / 2;
      if (currentTime < 1) {
        return (change / 2) * currentTime * currentTime + start;
      }
      currentTime -= 1;
      return (-change / 2) * (currentTime * (currentTime - 2) - 1) + start;
    },
    doScroll() {
      if (this.once) {
        this.once = false;
        var that = this;
        //icon-menu height

        var previousIndex = -2;
        var currentIndex = -1;

        localStorage.setItem("animating", false);
        $$(".store-menu-mobile>li>a").on("click", function (event) {
          $$(".store-menu-mobile li").removeClass("active");

          // Make sure this.hash has a value before overriding default behavior
          if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();
            $$(this).parent().addClass("active");
            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            localStorage.setItem("animating", true);
            var scrollto =
              $$(hash).offset().top -
              $$("#section-" + that.categories[0].ID).offset().top +
              (that.showPopular ? 258 : 0);
            if (
              that.$root &&
              that.$root.$refs &&
              that.$root.$refs.Productlist &&
              that.$root.$refs.Productlist.$refs &&
              that.$root.$refs.Productlist.$refs.scrollview
            ) {
              that.scrollTo(
                that.$root.$refs.Productlist.$refs.scrollview,
                scrollto,
                300
              );
            }
          } // End if
        });
        var links = $$(".store-menu-mobile a");
        var sections = links.toArray().map((i) => {
          return i.hash;
        });
        // Setup a timer
        var timeout;
        // Listen for scroll events
        if (
          that.$root &&
          that.$root.$refs &&
          that.$root.$refs.Productlist &&
          that.$root.$refs.Productlist.$refs &&
          that.$root.$refs.Productlist.$refs.scrollview
        ) {
          that.$root.$refs.Productlist.$refs.scrollview.addEventListener(
            "scroll",
            function () {
              if (localStorage.getItem("animating") == "false") {
                // If there's a timer, cancel it
                if (timeout) {
                  window.cancelAnimationFrame(timeout);
                }
                // Setup the new requestAnimationFrame()
                timeout = window.requestAnimationFrame(function () {
                  // Run our scroll functions
                  var scrollTop = $(window).scrollTop();

                  for (let index = sections.length - 1; index >= 0; index--) {
                    const element = sections[index];
                    if (
                      $$(element).offset() &&
                      scrollTop >=
                        $$(element).offset().top -
                          (171 +
                            (!that.showPopular && that.ReorderStatus ? 166 : 0))
                    ) {
                      previousIndex = currentIndex;
                      currentIndex = index;
                      if (previousIndex != currentIndex) {
                        var id = $$(element).attr("id");
                        links.parent().removeClass("active");
                        var current = links.filter("[href*='#" + id + "']");
                        current.parent().addClass("active");
                        if (id != "section-search") {
                          current.parent().trigger("click");
                        } else {
                          that.updateSelected({ ID: "search" });
                        }
                        var menu = $$(".store-menu-mobile");
                        if (currentIndex % 2 == 0) {
                          $$(menu).animate(
                            {
                              scrollLeft:
                                $$(menu).scrollLeft() +
                                $$(current).parent().offset().left -
                                100,
                            },
                            100
                          );
                        }
                      }
                      break;
                    }
                  }
                });
              }
            },
            false
          );
        }
      }
    },
    updateSelected(category) {
      this.selected = category;
    },
    itemStyle(category) {
      var style = [];
      if (this.selected && category && this.selected.ID == category.ID) {
        style.push(this.mobileStyles.MenuHighlightedText);
        style.push(this.mobileStyles.MenuHighlight);
      } else {
        style.push(this.mobileStyles.CommonColorTxt);
      }
      return style;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      Validator.localize(locale, locale == "en" ? en : zh_CN);
      this.setCurrentLocale(locale);
    },
    showLogoError() {
      this.showLogo = false;
    },
    navigateToHome() {
      var url = this.getMobileEmbededReturnUrl;
      if (url) {
        window.location = url;
      }
    },
    navigateToPayAtTable() {
      const table = this.storeTable;
      const storeID = this.$route.params.storeid;
      window.location.href = `${AppConfig.payAtTable}/${storeID}/?table=${table}`;
    },
    openDietary() {
      this.showDietary = !this.showDietary;
    },
    allergyChecked(dietary) {
      if (this.getDietarySelection.Allergy.some((s) => s.Id == dietary.Id)) {
        this.setAllergySelected(
          this.getDietarySelection.Allergy.filter((s) => s.Id != dietary.Id)
        );
      } else {
        this.setAllergySelected([...this.getDietarySelection.Allergy, dietary]);
      }
    },
    intoleranceChecked(intolerance) {
      if (
        this.getDietarySelection.Intolerance.some((s) => s.Id == intolerance.Id)
      ) {
        this.setIntoleranceSelected(
          this.getDietarySelection.Intolerance.filter(
            (s) => s.Id != intolerance.Id
          )
        );
      } else {
        this.setIntoleranceSelected([
          ...this.getDietarySelection.Intolerance,
          intolerance,
        ]);
      }
    },
    preferencesChecked(preferences) {
      if (
        this.getDietarySelection.Preference.some((s) => s.Id == preferences.Id)
      ) {
        this.setPreferenceSelected(
          this.getDietarySelection.Preference.filter(
            (s) => s.Id != preferences.Id
          )
        );
      } else {
        this.setPreferenceSelected([
          ...this.getDietarySelection.Preference,
          preferences,
        ]);
      }
    },
    clearAllDietarySelection() {
      this.setAllergySelected([]);
      this.setIntoleranceSelected([]);
      this.setPreferenceSelected([]);
    },
    getStyle() {
      var style = [];
      if (this.value) {
        style.push(this.mobileStyles.CommonColorBackground);
      } else {
        style.push(this.mobileStyles.pendingStatusBackground);
      }
      return style;
    },
    getIconStyle(item) {
      if (item && item.Name)
        return [
          {
            "background-image": `url(https://abacus-asset.firebaseapp.com/onlineordering/images/dietary/icon/abacus_dietary_${item.Name.split(
              " "
            ).join("")}.png)`,
          },
        ];
      else return [];
    },
    getSearchIconRolldStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push({ "margin-top": "-5px" });
        styles.push(this.mobileStyles.MagnifyColor);
      }
      return styles;
    },
    getSearchRolldStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push(this.mobileStyles.primaryBodyBackground);
        styles.push({ "margin-top": "2px" });
      }
      return styles;
    },
    getSearchContainerRolldStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push({ "border-top": "1px solid #d9d9d9" });
        styles.push({ "border-bottom": "1px solid #d9d9d9" });
      }
      if (this.showNewUi) {
        styles.push({ "margin-bottom": "5px" });
      }
      return styles;
    },
    getSearchSectionStyle() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push({ width: "150%" });
      }
      return styles;
    },
    getDrawerMenuStyle() {
      let styles = [];
      if (this.showNewUi) {
        styles.push({ fontSize: "30px" });
      }
      styles.push(this.mobileStyles.navText);
      return styles;
    },
    getHeaderStyle() {
      let styles = [];
      styles.push(this.mobileStyles.TitleBar);
      styles.push(this.mobileStyles.navText);

      return styles;
    },
    getIconClass() {
      if (this.isRolldStore()) {
        return "rolld-primary-color";
      }
      if (this.showNewUi) {
        return "text-dark";
      }

      return "text-white";
    },
    getDietaryClass() {
      if (this.showNewUi) {
        return "new-dietary";
      }
      return "dietary";
    },
    getDietaryStyle() {
      let style = [];
      if (this.showNewUi) {
        style.push(this.mobileStyles.ButtonText);
      }
      return "dietary";
    },
    getCategoryName(category) {
      //  get category name based on language
      const locale = this.$i18n.locale;
      if (locale === "en" || !category.Translations) {
        return category.Name;
      }

      const translatedName = category.Translations.find(
        (t) => t.Culture === locale
      );
      return translatedName && translatedName.Name
        ? translatedName.Name
        : category.Name;
    },
  },
};
</script>
<style scoped>
.language {
  margin-left: 10px;
}
.oo-module .mobile-wrapper .lg-dropdown-menu:after {
  right: 12% !important;
}
</style>
